import { StatusCellComponent } from '@shared/components/table/cells/status-cell/status-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';

/**
 * isChild Status Column
 * Shows red, green states
 */
export const isChildPartial: Columns<any> = {
  title: 'meter.child',
  key: 'isChild',
  cellRenderer: StatusCellComponent,
  cellRendererParams: {
    0: { color: 'bg-red-500', label: 'common.no' },
    1: { color: 'bg-green-500', label: 'common.yes' },
  }
}
